import { render } from "./builder.vue?vue&type=template&id=1e5259e4&scoped=true"
import script from "./builder.vue?vue&type=script&lang=js"
export * from "./builder.vue?vue&type=script&lang=js"

import "./builder.vue?vue&type=style&index=0&id=1e5259e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e5259e4"]])

export default __exports__